import { format } from "date-fns";

//Дата для INPUT
export default function StringToInputDate(date_str) {
    if (date_str != undefined & date_str != null & date_str != '') {
        return format(new Date(date_str), 'yyyy-MM-dd')
    }
    return null;
}